import { Card, styled } from "@health-zelas/delta"

export const Wrapper = styled('div', {
  maxWidth: '47rem',
  paddingBottom: '$md'
})

export const ButtonGroup = styled('div', {
  marginBottom: '$xs',
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: '$xxxs'
})

export const ProductList = styled('div', {
  display: 'grid',
  gap: '$xxs',

  '@sm': {
    gridTemplateColumns: 'repeat(2, 1fr)'
  }
})

export const ProductCard = styled(Card, {
  padding: '$md',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'start',
  gap: '$xxs'
})

export const ProductCardLogo = styled('img', {
  height: 64,
  objectFit: 'contain'
})

export const ProductCardPrice = styled('strong', {
  fontWeight: '$bold',
  fontSize: '$xlg',
  color: '$primaryMedium',

  span: {
    fontSize: '$xxs',
    fontWeight: '$regular',
  }
})
